import { compose, createStore, applyMiddleware} from 'redux';
import Thunk from 'redux-thunk';
import {namespace} from './common/Utils';
import reducer from './reducer';
import {actions} from './reducer';
import Router from './Router';

import SearchBox from './components/SearchBox';
import SearchFilterJob from './components/SearchFilterJob';
import SearchList from './components/SearchList';
import RecentViewChar from './components/RecentViewChar';

import CharMain from './components/CharMain';
import CharCompare from './components/CharCompare';
import NotAllowed from './components/NotAllowed';

import {l10n} from './L10n';

class App {
    constructor(_config = {}) {
        console.log('---------------------------- App start ----------------------------??');

        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        this.store = createStore(reducer, composeEnhancers(applyMiddleware(Thunk)));
        this.store.dispatch(actions.setConfig(_config));
        this.store.dispatch(actions.setIsAllowed(_config.isAllowed));
        this.router = new Router( this.store );

        let _l10n = l10n[$('html').attr('lang') || 'ko'];

        this.search = new SearchBox('SearchBox', this.store, actions, this.router, '', _l10n);
        this.searchFilterJob = new SearchFilterJob('SearchFilterJob', this.store, actions, this.router, '.job-filter-list', _l10n);
        this.searchList = new SearchList('SearchList', this.store, actions, this.router, 'section.result-list-wrap', _l10n);
        this.recentViewChar = new RecentViewChar('RecentViewChar', this.store, actions, this.router, '', _l10n);

        this.charMain = new CharMain('CharMain', this.store, actions, this.router, '', _l10n);
        this.charCompare = new CharCompare('CharCompare', this.store, actions, this.router, '', _l10n);
        this.notAllowed = new NotAllowed('NotAllowed', this.store, actions, this.router, '', _l10n);
        
        this.router.init();
    }
}

namespace('nc.bns.ingamechar');
nc.bns.ingamechar = App;